import { CONFIG } from "../../../config";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import dayjs from 'dayjs';


const CRMCONFIG = CONFIG.modules['crm'];
const API_HOST_CRM = CRMCONFIG.host;


export const useGetCaseAnalyticsQueue = (fromDate, toDate, fetchKey) => {
  const fetchCaseAnalytics = async () => {
    try {
      const response = await axios.get(`${API_HOST_CRM}/analytics/case-analytics-queue`, {
        params: { from: fromDate.format('YYYY-MM-DD'), to: toDate.format('YYYY-MM-DD') },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching case analytics queue:", error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ["caseAnalyticsQueue", fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'), fetchKey],
    queryFn: fetchCaseAnalytics,
    refetchOnWindowFocus: false,
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    onError: (error) => {
      console.error("Error in useGetCaseAnalyticsQueue:", error);
    },
  });
};